import React from 'react';

import { AddIconButton } from 'packages/common-frontend/components/IconButton';

type AddButtonProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const AddButton = ({ setIsOpen }: AddButtonProps) => {
  return (
    <AddIconButton
      ariaLabel="add"
      label="Add"
      onClick={() => setIsOpen(true)}
    />
  );
};
